import React from 'react'
import {useNavigate} from 'react-router-dom'
import { home } from '../../config/routingConsts'
const NotFound = () => {


  const navigate = useNavigate()
  return (
    <>
      <div className='admin-card page-not-found'>
        <h1>404</h1>
        <h3>Page Not Found</h3>
        <p>The page you were looking for could not be found. It might have been removed, renamed, or did not exist in the first place.</p>
        <button onClick={()=>navigate(home)} className="solid-red-btn" style={{borderRadius:"5px"}}>Go To Home</button>
      </div>
    </>
  )
}

export default NotFound